import React, { useState } from "react";

const SimpleCheckbox = ({
  name,
  label,
  onChange,
  isDisabled = false,
  isLabelLeft = false,
  checked: checkedProp,
}) => {
  const [checked, setChecked] = useState(!!checkedProp);

  const handleCheckboxChange = (event) => {
    setChecked(event.target.checked);
    if (onChange) {
      onChange(name, event.target.checked);
    }
  };

  return (
    <div>
      <div className="checkbox-field-wrapper">
        {isLabelLeft && <label htmlFor={name}>{label}</label>}
        <input
          id={name}
          name={name}
          className={`checkbox-field ${isDisabled ? "cursor-not-allowed" : ""}`}
          type="checkbox"
          checked={checked}
          onChange={handleCheckboxChange}
          disabled={isDisabled}
        />
        {!isLabelLeft && (
          <label htmlFor={name} className="text-nowrap">
            {label}
          </label>
        )}
      </div>
    </div>
  );
};

export default SimpleCheckbox;
